// extracted by mini-css-extract-plugin
export default {"cityChooser":"c-j_ef","cityChooser__text":"c-j_eg","cityChooser__placeholder":"c-j_eh","cityChooser__buttonIcon":"c-j_ei"};